// import Swiper JS
import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import loadSvg from '../../utils/svg'
// import Swiper styles

(function ($) {

  if($('.horizontal-post-swiper').length > 0) {
    let index = 0
    let swiper;
    let that;

    $('.horizontal-post-swiper').each(function(){
      $(this).addClass('horizontal-post-swiper-'+index);

      if ($(this).find('.swiper-slide').length > 1) {
        $(this).removeClass('not-active')

        that = $('horizontal-post-swiper-'+index);
  
        let centered = ($(this).data('centered')) ? $(this).data('centered') : false;
        let loop = ($(this).data('loop') && $(this).data('loop') !== 'false') ? $(this).data('loop') : false;

        swiper = new Swiper('.horizontal-post-swiper-'+index, {
          autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          centeredSlides: centered,
          spaceBetween: 0,
          direction: 'horizontal',
          grabCursor: true,
          loop: loop,
          modules: [Autoplay, Navigation],
          navigation: {
            nextEl: ".horizontal-post-swiper-"+ index +" .swiper-button-next",
            prevEl: ".horizontal-post-swiper-"+ index +" .swiper-button-prev",
          },
          slidesPerView: "auto",
        });

        if ($(this).closest('.elementor-widget-container').find('.autoplay').length > 0) {
          let speed = $(this).closest('.elementor-widget-container').find('.autoplay').data('speed');
          swiper.params.autoplay.delay = speed;
        }

        if($('.pages', this).length > 0) {
          let clicked = false;

          swiper.on('transitionStart', function (e) {
            if(!clicked) {
              that.find('.pages a').removeClass('active');
              that.find('.pages a', this).eq(swiper.realIndex).addClass('active');
            }
            clicked = false;
          });

          $('.pages a', this).click(function(){
            let eq = $(this).data('id') - 1;
            if (loop) {
                swiper.slideToLoop(eq);
            } else {
                swiper.slideTo(eq);
            }
            return false;
          });
        }

      } else {
        $(this).find('.swiper-slide').addClass('swiper-slide-active');
        $(this).closest('section').css('box-shadow','none')
      }
    });
    
    index++;
  }

  if($('.awards').length > 0) {
    console.log('awwwards')
    let swiper = new Swiper('.awards-swiper', {
      autoplay: {
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      direction: 'horizontal',
      loop: false,
      modules: [ Autoplay, Navigation, Pagination ],
      navigation: {
        nextEl: ".awards-swiper .swiper-button-next",
        prevEl: ".awards-swiper .swiper-button-prev",
      },
      slidesPerGroup: 1,
      slidesPerView: "auto",
      spaceBetween: 0,
      breakpoints: {
        649: {
          slidesPerGroup: 2,
        },
        974: {
          slidesPerGroup: 3,
        },
        1298: {
          slidesPerGroup: 4,
        },
        1432: {
          slidesPerGroup: 5,
        },
        1856: {
          slidesPerGroup: 6,
        },
        2180: {
          slidesPerGroup: 7,
        },
        2504: {
          slidesPerGroup: 8,
        },
      },
      pagination: {
        el: ".pages",
        clickable: true,
        renderBullet: function (index, className) {
          let zero = (index < 9) ? 0 : '' ;
          return '<a href="#" class="' + className + '">' + zero + (index + 1) + "</a>";
        },
      },
    });

    if ($(this).closest('.elementor-widget-container').find('.autoplay').length > 0) {
      let speed = $(this).closest('.elementor-widget-container').find('.autoplay').data('speed');
      swiper.params.autoplay.delay = speed;
    }
  }

  if($('.milestones').length > 0) {

    $('.milestones').find('.pages a').each(function(){
      let year = $(this).text().replace(/\D/g,'');
      console.log('year')
      $(this).text(year);
    });

    let swiper = new Swiper('.milestones-swiper', {
      autoplay: {
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      centeredSlides: true,
      spaceBetween: 0,
      direction: 'horizontal',
      grabCursor: true,
      loop: false,
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: ".milestones .swiper-button-next",
        prevEl: ".milestones .swiper-button-prev",
      },
      slidesPerView: "auto",
      //speed: 350,
    });

    if($('.milestones .pages').length > 0) {
      let clicked = false;

      swiper.on('transitionStart', function (e) {
        if(!clicked) {
          $('.milestones').find('.pages a').removeClass('active');
          $('.milestones').find('.pages a').eq(swiper.realIndex).addClass('active');
        }
        clicked = false;
      });

      $('.milestones .pages a').click(function(){
        let eq = $(this).data('id') - 1;
        swiper.slideTo(eq);
        return false;
      });
    }

    if ($(this).closest('.elementor-widget-container').find('.autoplay').length > 0) {
      let speed = $(this).closest('.elementor-widget-container').find('.autoplay').data('speed');
      swiper.params.autoplay.delay = speed;
    }
  }

  $( document ).on( 'elementor/popup/show', ( event, id, instance ) => {


    if($('.elementor-popup-modal .swiper').length > 0) {
      let index = 0;
      let swiper;
      let that;
    
      $('img.svg').each(function() {
        loadSvg(this)
      });

      $('.elementor-popup-modal .swiper').each(function(){

        if ($(this).closest('.elementor-widget-container').find('.promotions-browse-text').length > 0) {
          $(this).find('.browse-all-text').text($('.promotions-browse-text').text());
        } else {
          $(this).find('.browse-all-text').hide();
        }

        if (!$(this).hasClass('swiper-initialized')) {
          $(this).addClass('horizontal-post-swiper-popup-'+index);

          if ($(this).find('.swiper-slide').length > 1) {
    
            that = $('horizontal-post-swiper-popup-'+index);
      
            let centered = ($(this).data('centered')) ? $(this).data('centered') : false;
            let loop = ($(this).data('loop') && $(this).data('loop') !== 'false') ? $(this).data('loop') : false;
            
            swiper = new Swiper('.horizontal-post-swiper-popup-'+index, {              
              autoplay: {
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              },
              centeredSlides: centered,
              spaceBetween: 0,
              direction: 'horizontal',
              grabCursor: true,
              loop: loop,
              modules: [Autoplay, Navigation],
              pauseOnMouseEnter: true,
              navigation: {
                nextEl: ".horizontal-post-swiper-popup-"+ index +" .swiper-button-next",
              },
              slidesPerView: "auto",
            });

            if ($(this).closest('.elementor-widget-container').find('.autoplay').length > 0) {
              let speed = $(this).closest('.elementor-widget-container').find('.autoplay').data('speed');
              swiper.params.autoplay.delay = speed;
            }
    
          } else {
            $(this).find('.swiper-slide').addClass('swiper-slide-active');
            $(this).closest('section').css('box-shadow','none')
            $(this).find('.swiper-button-next').hide();
          }
        }
        index++;
      });
    }

    $('img.svg').each(function() {
      loadSvg(this)
    });

  });

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partials/sliders/horizontal-post-slider.js